import React from 'react';
import { useTranslation } from 'react-i18next';

import { Page } from '@hotjar/webapp/components/Page';
import { PageTitle } from '@hotjar/webapp/components/PageTitle';

import { S } from './Styles';

export const Layout = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Page data-testid="team-invite-page-title">
      <PageTitle>{t('common:team-invite.page-title')}</PageTitle>
      <S.Header>{t('common:team-invite.organization')}</S.Header>
      <S.Content>{children}</S.Content>
    </Page>
  );
};
